import ReportDocumento from 'components/core/ReportDocumento';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { generateReceitaPdf } from './generateReceitaPdf';
import { ehReceitaLivre, ROTULO_RECEITA_LIVRE } from './receitaLivre';

export default function ReportReceita() {
  const location = useLocation();
  const { receita, medico } = location.state || {};
  const livre = ehReceitaLivre(receita);
  const tipoSuffix = livre ? 'Livre' : 'Timbrado';
  const nomePaciente = receita?.NOMEPAC ?? 'Paciente';

  const gerarBlob = useCallback(() => {
    return generateReceitaPdf({ receita });
  }, [receita]);

  return (
    <ReportDocumento
      documento={receita}
      gerarBlob={gerarBlob}
      fileName={`Receita-${tipoSuffix}-Prevencor-${nomePaciente}-${Date.now()}.pdf`}
      titulo={livre ? ROTULO_RECEITA_LIVRE : 'Relatório da Receita'}
      nomePaciente={receita?.NOMEPAC}
      iframeTitle="Receita Prevencor"
      emptyMessage="Nenhuma receita carregada."
      erroGeracao="Erro ao gerar o PDF da receita."
      sucessoMobile="Receita gerada com sucesso!"
      alertaTitulo={
        livre ? '⚠️ Confira a receita antes de imprimir' : '⚠️ Confira a receita antes do envio'
      }
      alertaCorpo={
        livre ? (
          <>
            O PDF contém o título RECEITA, o paciente, os dados do médico, o texto digitado e o
            espaço de assinatura e carimbo. Confira o conteúdo antes de imprimir. O envio pelo
            WhatsApp não está disponível.
          </>
        ) : (
          <>
            Visualize cuidadosamente o PDF e confirme se os dados do paciente, medicamentos,
            dosagens e orientações estão corretos. <br />
            Após a conferência, utilize o botão abaixo para enviar a receita pelo WhatsApp:
            <strong> "Enviar pelo WhatsApp"</strong>.<br /> Lembre-se de que, uma vez enviado, não
            será possível desfazer a ação.
          </>
        )
      }
      whatsapp={
        livre
          ? null
          : {
              celular: receita?.CELULARPAC,
              paciente: {
                id: receita?.CODPAC,
                nome: receita?.NOMEPAC,
                medico: medico?.apelido,
              },
              codLaudo: receita?.CODRECEITA,
              fileName: `Receita_${receita?.CODRECEITA}.pdf`,
              caption: `Olá *${receita?.NOMEPAC}*, tudo bem? 😊\n\nSegue em anexo a sua *Receita Médica*.\n\nQualquer dúvida, nossa equipe estará à disposição no setor de atendimento: (14) 3402-2700`,
            }
      }
    />
  );
}
